import React, { useState } from "react";
import {
  Box,
  TextField,
  Grid,
  MenuItem,
  Card,
  CardContent,
  Typography,
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Divider,
//   Checkbox,
//   FormControlLabel,
  Dialog,
  DialogContent,
  DialogTitle,
} from "@mui/material";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import BackdropLoader from "../../General/Loader";
import SnackBar from "../../General/SnackBar";
import { useEffect } from "react";
import { GetAllVendorListForSelect } from "API/VendorOnboarding/api";
import { ApprovePaymentOrder, CreatePaymentOrder } from "API/PaymentOrder/api";
import ConfirmationDialog from "./ConfirmModal";
// import { PostPurchaseOrder } from "API/PurchaseOrder/api";
import { FaDownload } from "react-icons/fa";


const ViewPaymentOrder = (props) => {
  let apihit=false;
  const [vendorDetails, setVendorDetails] = useState("");

  const [SelectedVendor, setSelectedVendor] = useState("")

  // const [shippingCost, setShippingCost] = useState(0);
//   const [applyIGST, setApplyIGST] = useState(true);
//   const [applyCGST, setApplyCGST] = useState(true);
//   const [applySGST, setApplySGST] = useState(true);
  // const [billToShipTo, setBillToShipTo] = useState("billTo");
  const [openPreview, setOpenPreview] = useState(false); // Dialog state for preview
  const [pdfUrl, setPdfUrl] = useState(null); // Blob URL for generated PDF
  const [AlertMessage, setAlertMessage] = useState(null)
  const [AlertType, setAlertType] = useState("success")
  const [AlertOpen, setAlertOpen] = useState(false)
  const [IsLoading, setIsLoading] = useState(false)
  const[PostAction,setPostAction]=useState(null)
  const[OpenRemarks,setOpenRemarks]=useState(false)
  const[Remarks,setRemarks]=useState("")

  const[DeviceData,setDeviceData]=useState(null)


  useEffect(()=>{
    if(props.data&&props.data.request_details){
      let devices = JSON.parse(JSON.stringify(Object.values(props.data?.request_details)));
      setDeviceData(devices);
    }
  },[props.data])


  console.log("Devices ",DeviceData,props.data);



  const handleOpenConfirmDialog = (action) => {
    setPostAction(action)
    setOpenRemarks(true)
  }

  const handleCloseConfirmDialog=()=>{
    setOpenRemarks(false)
  }


  // const [PostData, setPostData] = useState({})
  // const[Total,setTotal]=useState(null)
  // const[Tax,setTax]=useState({igst:null,cgst:null,sgst:null})

console.log("props",props);



const CalculateTotal=()=>{
  if(DeviceData){
    let total=0
    DeviceData.forEach((device)=>{
      total+=device.device_details.purchase_price*device.quantity
    })
    return parseFloat(total)
  }
}



  const formatDate = (date) => {
    const d = new Date(date);
    let month = '' + (d.getMonth() + 1);
    let day = '' + d.getDate();
    const year = d.getFullYear();

    if (month.length < 2) month = '0' + month;
    if (day.length < 2) day = '0' + day;

    return [year, month, day].join('-');
  };



  // const billTo={
  //   address:"1017, JMD MEGAPOLIS, SOHNA ROAD, SECTOR 48",
  //   name:"Chandan Kumar Das",
  //   email:"Chandan.das@fiaglobal.com",
  //   gstin:"06AABCF9386L1Z2",
  //   mobile_number:"6362302795"
  // }


  // console.log("propsdata", props);



  const handleAlertOpen = (message, type) => {
    setAlertMessage(message)
    setAlertType(type)
    setAlertOpen(true)
  }

  const handleCloseAlert = () => {
    setAlertOpen(false)
  }




  useEffect(() => {
    if(apihit){

      GetAllVendorListForSelect(setVendorDetails, setIsLoading, handleAlertOpen)
    }


  }, [])




  const handleVendorChange = (event) => {
    setSelectedVendor(event.target.value);
  };

  // const handleDeviceChange = (index, field, value) => {
  //   setDevices((prevDevices) =>
  //     prevDevices.map((device, i) =>
  //       i === index
  //         ? {
  //             ...device,
  //             [field]: value,
  //             total:
  //               field === "quantity"
  //                 ? (value * device.price).toFixed(2)
  //                 : device.total,
  //           }
  //         : device
  //     )
  //   );
  // };

  // const calculateSubTotal = (data) => {
  //   let total = 0


  //   Array.isArray(data) && data.forEach((device) => {
  //     // device.device_details.amount * device.quantity
  //     total += device.device_details.amount * device.quantity
  //   })
  //   return total + shippingCost
  // };

  const calculateTax = (amount) => {
    let igst = 0,
      cgst = 0,
      sgst = 0;

      igst = amount * 0.18; // IGST is 18%
      cgst = amount * 0.08; // CGST is 8%
      sgst = amount * 0.10; // SGST is 10%


    return {
      igst: igst.toFixed(2),
      cgst: cgst.toFixed(2),
      sgst: sgst.toFixed(2),
    };
  };


  // const handlePostPurchaseOrder = () => {
  //   let sub_total = calculateSubTotal(props.data.filter((item) => props.selectedItem.includes(item._id)))
  //   if (SelectedVendor && taxType && billToShipTo) {
  //     if (billToShipTo === 'shipTo') {
  //       if (shipToDetails.name !== "" && shipToDetails.email !== "" && shipToDetails.address !== "" && shipToDetails.mobile !== "" && shipToDetails.gstin !== "") {
  //         PostPurchaseOrder({ request_ids: props.selectedItem, vendor_id: SelectedVendor, address_type: billToShipTo, tax_type: taxType, ship_to: shipToDetails, additional_data: { sub_total: parseFloat(sub_total), shipping_cost: shippingCost, tax: calculateTax(sub_total), po_date: PoDate } }, setIsLoading, handleAlertOpen, setOpenPreview)
  //       }
  //       else {
  //         handleAlertOpen("Please fill all required fields for Ship To Details", "error")
  //         return
  //       }
  //     }
  //     else {
  //       PostPurchaseOrder({ request_ids: props.selectedItem, vendor_id: SelectedVendor, address_type: billToShipTo, tax_type: taxType, bill_to: billTo, additional_data: { sub_total: parseFloat(sub_total), shipping_cost: shippingCost, tax: calculateTax(sub_total), po_date: PoDate } }, setIsLoading, handleAlertOpen, setOpenPreview)
  //     }
  //   }
  //   else {
  //     handleAlertOpen("Please fill all required fields", "error")
  //     return
  //   }
  // }

  //   const calculateTotalCost = () => {
  //     const subTotal = parseFloat(calculateSubTotal(props.data.filter((item) => props.selectedItem.includes(item._id))));
  //     const { igst, cgst, sgst } = calculateTax(subTotal);
  //     const shipping = parseFloat(shippingCost || 0);

  //     // Total cost includes subtotal, taxes, and shipping cost
  //     return (subTotal + parseFloat(igst) + parseFloat(cgst) + parseFloat(sgst) + shipping).toFixed(2);
  //   };

const GetDeviceDataFromRequest=(id)=>{

    if(props.data&&props.data.quantity){
        let data=props.data.quantity.find(item => item.device_id === id)
        console.log("error",data);
        if(data){
          return {quantity:data.quantity,price:data.price}
        }
        return ""
    }
    else{
      return ""
    }

}



//   const handleQuantityChange = (index, value) => {
//     console.log( DeviceData[index],value);

//     if (value === '' || (/^[0-9]*$/.test(value) && value <= props.data.request_details[DeviceData[index]._id].quantity)) {
//         let dummy=[...DeviceData]
//         dummy[index].quantity=value
//         setDeviceData(dummy)
//       // setPostData({ ...PostData, [deviceDetails._id]: {quantity:value !== "" ? parseInt(value) : "",request_id:device._id} })
//       // setTotal(CalculateChangedTotal(value,deviceDetails.amount))
//       // setTax(CalculateChangedTax(value,deviceDetails.amount))
//     }
//     else{
//       handleAlertOpen("Value must be a valid number and must be lesser than the purchase order quantity","error")
//     }
//   }
 const TotalAmountDisplay = ( params ) => {
    console.log("params ",params);

    const totalAmount =
      params.total.quantity && Array.isArray(params.total.quantity)
        ? params.total.quantity.reduce((sum, item) => {
            if (item.price) {
              return parseFloat((sum + item.price)*1.00);
            }
            return parseFloat(sum*1.00);
          }, 0)
        : 0;

    return (
      <Typography variant="body1">
        <table>
          <tbody>
            <tr>
              <td>₹{(((parseFloat(totalAmount*1.00) + Number.EPSILON) * 100) / 100).toFixed(2)}</td>
            </tr>
          </tbody>
        </table>
      </Typography>
    );
  };

   const CalculateAmount = ( params ) => {

    console.log("params",params);
    

    const totalAmount =
    params.total.quantity && Array.isArray(params.total.quantity)
      ? params.total.quantity.reduce((sum, item) => {
          if (item.price) {
            return parseFloat((sum + item.price)*1.00);
          }
          return parseFloat(sum*1.00);
        }, 0)
      : 0;

          console.log("totalAmount ",totalAmount);
      return (
        <Typography variant="body1">
          <table>
            <tbody>
              <tr>
                {
                  params.total.purchase_order_details&&params.total.purchase_order_details.tax_type==="interstate"?
                  <td>₹{(((totalAmount+parseFloat(params.total.updated_tax.igst) + Number.EPSILON) * 100) / 100).toFixed(2)}</td>
                  :
                  <td>₹{(((totalAmount+parseFloat(params.total.updated_tax.cgst)+parseFloat(params.total.updated_tax.sgst) + Number.EPSILON) * 100) / 100).toFixed(2)}</td>

                }
              </tr>
            </tbody>
          </table>
        </Typography>
      );
    };

  const handleSubmit=()=>{
    let data=[]
    let error=false
    DeviceData.map((item)=>{
      if(item.quantity===""){
        handleAlertOpen("Please fill all the fields","error")
        error=true
        return
      }
      else{
        data.push({device_id:item.device_id,quantity:item.quantity,price:eval(item.quantity*item.device_details.amount)})
      }
    })
    if(!error){
      let tax=calculateTax((CalculateTotal()))
      CreatePaymentOrder({quantity:data,purchase_order_id:props.data._id,updated_tax:props.data.tax_type==="interstate"?{igst:tax.igst}:{cgst:tax.cgst,sgst:tax.sgst}},setIsLoading,handleAlertOpen);
    }

  }

  const handleApprove=()=>{
    ApprovePaymentOrder({payment_order_id:props.data._id,remarks:Remarks,status:PostAction,...props.UserRole},setIsLoading,handleAlertOpen)
  }

  // console.log(PostData);



  // pdf generator
  const generatePDF = () => {
    const element = document.getElementById("purchaseOrder");
    const previewButton = document.getElementById("previewButton");
    const vendorselect = document.querySelectorAll("#vendorselect");
    const downloadComponent = document.getElementById("downloadButton");

    if (!element) {
      console.error("Element with id 'purchaseOrder' not found.");
      return;
    }

    // Temporarily hide the Preview button
    if (previewButton) {
      previewButton.style.display = "none";
    }

    if (vendorselect) {
      vendorselect.forEach(element => {
        element.style.display = "none";
      });
    }

    if (downloadComponent) {
      downloadComponent.style.display = "none";
    }

    html2canvas(element, {
      scale: 2, // High resolution for better quality
      useCORS: true, // Allow cross-origin resources
      scrollY: -window.scrollY, // Include off-screen content
    })
      .then((canvas) => {
        const pdf = new jsPDF("p", "mm", "a4");
        const pdfWidth = pdf.internal.pageSize.getWidth();
        const pdfHeight = pdf.internal.pageSize.getHeight();

        const canvasWidth = canvas.width;
        const canvasHeight = canvas.height;
        const imgHeight = (pdfWidth * canvasHeight) / canvasWidth;

        let heightLeft = imgHeight;
        let position = 10; // Padding from the top

        // Convert canvas to image
        const imgData = canvas.toDataURL("image/png");

        // Draw border with padding
        pdf.setDrawColor(0); // Black border color
        pdf.setLineWidth(0.2);
        pdf.rect(5, 5, pdfWidth - 10, pdfHeight - 10); // x, y, width, height

        // Add the first page
        pdf.addImage(imgData, "PNG", 10, position, pdfWidth - 20, imgHeight);
        heightLeft -= pdfHeight;

        // Add additional pages if content exceeds one page
        while (heightLeft > 0) {
          position -= pdfHeight;
          pdf.addPage();
          pdf.rect(5, 5, pdfWidth - 10, pdfHeight - 10); // Maintain border on all pages
          pdf.addImage(imgData, "PNG", 10, position, pdfWidth - 20, imgHeight);
          heightLeft -= pdfHeight;
        }

        // Generate Blob URL for preview
        const blob = pdf.output("blob");
        const url = URL.createObjectURL(blob);
        setPdfUrl(url); // Set the Blob URL for preview
        setOpenPreview(true); // Open the preview dialog
      })
      .catch((err) => {
        console.error("Error generating PDF:", err);
      })
      .finally(() => {
        // Restore the Preview button visibility
        if (previewButton) {
          previewButton.style.display = "block";
        }
        if (downloadComponent) {
          downloadComponent.style.display = "inline";
        }
        if (vendorselect) {
          vendorselect.forEach(element => {
            element.style.display = "block";
          });
        }
      });
  };



  return (
    <Box id="purchaseOrder" p={3} sx={{ breakInside: 'avoid' }}>
      <ConfirmationDialog handleClose={handleCloseConfirmDialog} open={OpenRemarks} remarks={Remarks} setRemarks={setRemarks} IsLoading={IsLoading} handleSubmit={handleApprove}/>
      <BackdropLoader open={IsLoading} />
      <SnackBar open={AlertOpen} message={AlertMessage} type={AlertType} handleClose={handleCloseAlert} />
      <Typography variant="h4" gutterBottom>
        Payment Order <Button variant="text" color="secondary" id="downloadButton" onClick={()=>generatePDF()}><FaDownload /></Button>
      </Typography>

      <Card variant="outlined">
        <CardContent>
          {/* Purchase Order Details */}
          <Grid container spacing={2} flexDirection="column">

            <Grid item xs={4}>
              <TextField
                disabled
                label="Purchase Order ID"
                fullWidth
                size="small"
                value={props.data?.payment_order_id}
                InputLabelProps={{
                  shrink: true,
                }}
                variant="standard" />
            </Grid>
            <Grid item xs={4}>
              <TextField
                label="Purchase Request Id"
                fullWidth
                size="small"
                variant="standard"
                value={props.data && props.data.purchase_request_details&&Array.isArray(props.data.purchase_request_details) ? props.data.purchase_request_details.map((item) => item.purchase_request_id) : ""}
                InputLabelProps={{
                  shrink: true,
                }}
              />
            </Grid>
            <Grid item xs={4}>
              <TextField
                label="PO Date"
                value={formatDate(props.data.purchase_order_details?.po_date)}
                type="date" onChange={(e) => setPODate(e.target.value)}
                fullWidth
                size="small"
                variant="standard"
                InputLabelProps={{ shrink: true }}
                inputProps={{
                  readOnly: true,
                }}
              />
            </Grid>
          </Grid>

          {/* Vendor Details and Bill To Address Side by Side */}
          <Box mt={3}>
            <Grid display="none" container spacing={2}>
              <Grid item xs={6}>
                <Typography variant="h6">Order To</Typography>
                <Grid container spacing={2} padding={1} display="none">
                  <Grid item xs={12} id="vendorselect">
                    <TextField
                      id="vendorselect"
                      select
                      label="Vendor Name"
                      fullWidth
                      size="small"
                      value={SelectedVendor}
                      onChange={handleVendorChange}
                    >
                      <MenuItem value="">Select</MenuItem>
                      {vendorDetails && vendorDetails.map((item, index) => (
                        <MenuItem key={index} value={item._id}>{item.vendor_name}</MenuItem>
                      ))}
                    </TextField>
                  </Grid>
                </Grid>
                <Card variant="outlined" style={{ maxHeight: "100%", minHeight: 100, overflow: "auto" }}>
                  <CardContent>
                    <Grid container spacing={2}>

                      {props.data && props.data.vendor_details &&
                        <>
                          <Grid item xs={12}>
                            <TextField
                              label="Company Name"
                              fullWidth
                              size="small"
                              variant="standard"
                              value={props.data.vendor_details.company_name}
                              inputProps={
                                {
                                  readOnly: true,
                                }
                              }
                            />
                          </Grid>

                          <Grid item xs={12}>
                            <TextField
                              label="Contact Name/ID"
                              fullWidth
                              size="small"
                              variant="standard"
                              value={props.data.vendor_details.vendor_name}
                              inputProps={
                                {
                                  readOnly: true,
                                }
                              }
                            />
                          </Grid>

                          <Grid item xs={12}>
                            <TextField
                              label="Address"
                              fullWidth
                              size="small"
                              variant="standard"
                              value={props.data.vendor_details.address}
                              inputProps={
                                {
                                  readOnly: true,
                                }
                              }
                            />
                          </Grid>

                          <Grid item xs={6}>
                            <TextField
                              label="City"
                              fullWidth
                              size="small"
                              variant="standard"
                              value={props.data.vendor_details.city_name}
                              inputProps={
                                {
                                  readOnly: true,
                                }
                              }
                            />
                          </Grid>

                          <Grid item xs={6}>
                            <TextField
                              label="Pincode"
                              fullWidth
                              size="small"
                              variant="standard"
                              value={props.data.vendor_details.pin_code}
                              inputProps={
                                {
                                  readOnly: true,
                                }
                              }
                            />
                          </Grid>

                          <Grid item xs={12}>
                            <TextField
                              label="Mobile Number"
                              fullWidth
                              size="small"
                              variant="standard"
                              value={props.data.vendor_details.mobile_number}
                              inputProps={
                                {
                                  readOnly: true,
                                }
                              }
                            />
                          </Grid>

                          <Grid item xs={12}>
                            <TextField
                              label="GSIT No"
                              fullWidth
                              size="small"
                              variant="standard"
                              value={props.data.vendor_details.gst_number}
                              inputProps={
                                {
                                  readOnly: true,
                                }
                              }
                            />
                          </Grid>

                          <Grid item xs={12}>
                            <TextField
                              label="Email"
                              fullWidth
                              size="small"
                              variant="standard"
                              inputProps={
                                {
                                  readOnly: true,
                                }
                              }
                              value={props.data.vendor_details.email_address}

                            />
                          </Grid>
                        </>

                      }
                    </Grid>
                  </CardContent>
                </Card>
              </Grid>

              <Grid item xs={6}>
                <Typography variant="h6">Order By</Typography>
                <Grid container spacing={2} padding={1} id="vendorselect">
                  <Grid item xs={12} visibility="hidden" id="vendorselect" display="none">
                    <TextField
                      select
                      variant="standard"
                      label="Vendor Name"
                      fullWidth
                      size="small"
                      value={SelectedVendor}
                      onChange={handleVendorChange}
                    >
                      <MenuItem value="">Select</MenuItem>
                      {vendorDetails && vendorDetails.map((item, index) => (
                        <MenuItem key={index} value={item._id}>{item.vendor_name}</MenuItem>
                      ))}
                    </TextField>
                  </Grid>
                </Grid>
                <Card variant="outlined" style={{ maxHeight: "100%", minHeight: 100, overflow: "auto" }}>
                  <CardContent>
                    <Grid container spacing={2}>

                      <>
                        <Grid item xs={12} >
                          <TextField
                            label="Contact Name"
                            fullWidth
                            size="small"
                            value="Chandan Kumar Das"
                            variant="standard"
                            inputProps={{
                              readOnly: true,
                            }}
                          />
                        </Grid>
                        <Grid item xs={12}>
                          <TextField
                            label="Company Name"
                            fullWidth
                            size="small"
                            variant="standard"
                            inputProps={{
                              readOnly: true,
                            }}
                            value="FIA TECHNOLOGY SERVICES PVT LTD "

                          />
                        </Grid>
                        <Grid item xs={12}>
                          <TextField
                            label="Address"
                            fullWidth
                            size="small"
                            variant="standard"
                            inputProps={{
                              readOnly: true,
                            }}
                            value="1017, JMD MEGAPOLIS, SOHNA ROAD, SECTOR 48"

                          />
                        </Grid>

                        <Grid item xs={6}>
                          <TextField
                            label="City"
                            fullWidth
                            size="small"
                            variant="standard"
                            inputProps={{
                              readOnly: true,
                            }}
                            value="Gurugram"

                          />
                        </Grid>
                        <Grid item xs={6}>
                          <TextField
                            label="Pincode"
                            fullWidth
                            size="small"
                            variant="standard"
                            inputProps={{
                              readOnly: true,
                            }}
                            value="122018"

                          />
                        </Grid>

                        <Grid item xs={12}>
                          <TextField
                            label="Mobile Number"
                            fullWidth
                            size="small"
                            variant="standard"
                            inputProps={{
                              readOnly: true,
                            }}
                            value="6362302795"

                          />
                        </Grid>

                        <Grid item xs={12}>
                          <TextField
                            label="GST No."
                            fullWidth
                            size="small"
                            variant="standard"
                            inputProps={{
                              readOnly: true,
                            }}
                            value="06AABCF9386L1Z2"

                          />
                        </Grid>

                        <Grid item xs={12}>
                          <TextField
                            label="Email"
                            fullWidth
                            size="small"
                            variant="standard"
                            inputProps={{
                              readOnly: true,
                            }}
                            value="Chandan.das@fiaglobal.com"

                          />
                        </Grid>
                      </>

                    </Grid>
                  </CardContent>
                </Card>
              </Grid>
            </Grid>
          </Box>

          {/* Device Details */}
          <Box mt={3}>
            <Typography variant="h6">Device Details</Typography>
            <Card variant="outlined">
              <CardContent>
                <TableContainer component={Paper}>
                  <Table size='small'>
                    <TableHead>
                      <TableRow>
                        <TableCell>Brand Name</TableCell>
                        <TableCell>Device Name</TableCell>
                        <TableCell>Model Number</TableCell>
                        <TableCell>Quantity</TableCell>
                        <TableCell>Price</TableCell>
                        <TableCell>Total</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {

                        // props.data.filter((item) => props.selectedItem.includes(item._id)).map((device, index) => (
                        //   <TableRow key={index}>
                        //     <TableCell>{device.device_details.brand_name}</TableCell>
                        //     <TableCell>{device.device_details.name}</TableCell>
                        //     <TableCell>{device.device_details.model}</TableCell>
                        //     <TableCell>
                        //       {device.quantity}
                        //     </TableCell>
                        //     <TableCell>₹{device.device_details.amount}</TableCell>
                        //     <TableCell>₹{eval(device.device_details.amount * device.quantity)}</TableCell>
                        //   </TableRow>
                        // ))

                        props.data&&props.data.purchase_request_details &&Array.isArray(props.data.purchase_request_details)&&
                        props.data.purchase_request_details
                          .map((device, index) => (
                            <TableRow key={index}>
                              <TableCell>{device.device_details.brand_name}</TableCell>
                              <TableCell>{device.device_details.name}</TableCell>
                              <TableCell>{device.device_details.model}</TableCell>
                              <TableCell>
                               {GetDeviceDataFromRequest(device.device_details._id).quantity}
                              </TableCell>
                              <TableCell>₹{device.device_details.purchase_price?device.device_details.purchase_price:"-"}</TableCell>
                              <TableCell>₹{GetDeviceDataFromRequest(device.device_details._id).price}</TableCell>
                            </TableRow>
                          ))

                      }
                    </TableBody>
                  </Table>
                </TableContainer>
              </CardContent>
            </Card>
          </Box>


          {/* Tax Section & Shipping Cost */}
          <Box mt={3} display="none">
            <Typography variant="h6" gutterBottom>
              Tax & Shipping Cost
            </Typography>
             <Card variant="outlined" sx={{ backgroundColor: "#f9f9f9", boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)" }}>
                          <CardContent>
                            <Grid container spacing={2}>
                              {/* Subtotal */}
                              <Grid item xs={12}>
                                <Box display="flex" justifyContent="space-between">
                                  <Typography variant="body1" fontWeight="bold">
                                    Subtotal:
                                  </Typography>
                                  <TotalAmountDisplay total={props.data}/>
                                </Box>
                              </Grid>

                              {/* Tax Details */}
                              { props.data &&props.data.purchase_order_details&& props.data.purchase_order_details.tax_type === "interstate" && (
                                <Grid item xs={12}>
                                  <Box display="flex" justifyContent="space-between">
                                    <Typography variant="body1" fontWeight="bold">
                                      IGST (18%):
                                    </Typography>
                                    <Typography variant="body1">₹{props.data && props.data.updated_tax?.igst}</Typography>
                                  </Box>
                                </Grid>
                              )}
                              {props.data.purchase_order_details&& props.data.purchase_order_details.tax_type === "intrastate" && (
                                <Grid item xs={12}>
                                  <Box display="flex" justifyContent="space-between">
                                    <Typography variant="body1" fontWeight="bold">
                                      CGST (8%):
                                    </Typography>
                                    <Typography variant="body1">₹{props.data && props.data.updated_tax?.cgst}</Typography>
                                  </Box>
                                </Grid>
                              )}
                              {props.data.purchase_order_details&& props.data.purchase_order_details.tax_type === "intrastate" && (
                                <Grid item xs={12}>
                                  <Box display="flex" justifyContent="space-between">
                                    <Typography variant="body1" fontWeight="bold">
                                      SGST (10%):
                                    </Typography>
                                    <Typography variant="body1">₹{props.data && props.data.updated_tax?.sgst}</Typography>
                                  </Box>
                                </Grid>
                              )}

                              {/* Divider */}
                              <Divider sx={{ width: "100%", my: 2 }} />

                              {/* Total Cost */}
                              <Grid item xs={12}>
                                <Box display="flex" justifyContent="space-between">
                                  <Typography variant="h6" fontWeight="bold">
                                    Total Cost:
                                  </Typography>
                                  <Typography variant="h6" fontWeight="bold" color="secondary">
                                    {<CalculateAmount total={props.data}/>}
                                  </Typography>
                                </Box>
                              </Grid>
                            </Grid>
                          </CardContent>
                        </Card>
          </Box>



          {/* Invoice Summary */}
          <Box mt={3}>
            <Typography variant="h6" gutterBottom>
              Invoice Summary
            </Typography>
            <Card variant="outlined" sx={{ backgroundColor: "#f9f9f9", boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)" }}>
                          <CardContent>
                            <Grid container spacing={2}>
                              {/* Subtotal */}
                              <Grid item xs={12}>
                                <Box display="flex" justifyContent="space-between">
                                  <Typography variant="body1" fontWeight="bold">
                                    Subtotal:
                                  </Typography>
                                  <TotalAmountDisplay total={props.data}/>
                                </Box>
                              </Grid>

                              {/* Tax Details */}
                              {props.data &&props.data.purchase_order_details&& props.data.purchase_order_details.tax_type === "interstate" && (
                                <Grid item xs={12}>
                                  <Box display="flex" justifyContent="space-between">
                                    <Typography variant="body1" fontWeight="bold">
                                      IGST (18%):
                                    </Typography>
                                    <Typography variant="body1">₹{props.data && props.data.updated_tax?.igst}</Typography>
                                  </Box>
                                </Grid>
                              )}
                              {props.data.purchase_order_details&& props.data.purchase_order_details.tax_type === "intrastate" && (
                                <Grid item xs={12}>
                                  <Box display="flex" justifyContent="space-between">
                                    <Typography variant="body1" fontWeight="bold">
                                      CGST (8%):
                                    </Typography>
                                    <Typography variant="body1">₹{props.data && props.data.updated_tax?.cgst}</Typography>
                                  </Box>
                                </Grid>
                              )}
                              {props.data.purchase_order_details&& props.data.purchase_order_details.tax_type === "intrastate" && (
                                <Grid item xs={12}>
                                  <Box display="flex" justifyContent="space-between">
                                    <Typography variant="body1" fontWeight="bold">
                                      SGST (10%):
                                    </Typography>
                                    <Typography variant="body1">₹{props.data && props.data.updated_tax?.sgst}</Typography>
                                  </Box>
                                </Grid>
                              )}

                              {/* Divider */}
                              <Divider sx={{ width: "100%", my: 2 }} />

                              {/* Total Cost */}
                              <Grid item xs={12}>
                                <Box display="flex" justifyContent="space-between">
                                  <Typography variant="h6" fontWeight="bold">
                                    Total Cost:
                                  </Typography>
                                  <Typography variant="h6" fontWeight="bold" color="secondary">
                                    {<CalculateAmount total={props.data}/>}
                                  </Typography>
                                </Box>
                              </Grid>
                            </Grid>
                          </CardContent>
                        </Card>
          </Box>








          {/* Bill To / Ship To Section */}
          <Box mt={3}>
            <Typography display="none" variant="h6" gutterBottom>
              Bill To / Ship To
            </Typography>
            <Card variant="outlined" sx={{ p: 3 }}>
              {/* Header Section */}
              <Box display="none" alignItems="center" justifyContent="space-between" mb={3}>
                <TextField
                  select
                  label="Bill To / Ship To"
                  size="small"
                  value={props.data?.address_type}
                  onChange={(e) => setBillToShipTo(e.target.value)}
                  sx={{ minWidth: "200px" }}
                  variant="standard"
                  inputProps={
                    {
                      readOnly: true,
                    }
                  }
                >
                  <MenuItem value="billTo">Bill To</MenuItem>
                  <MenuItem value="shipTo">Ship To</MenuItem>
                </TextField>
              </Box>

              <Grid container spacing={4} alignItems="flex-start">
                {/* Billing Details Section */}
                <Grid item xs={12}>
                  <Typography variant="subtitle1" gutterBottom>
                    Vendor Details
                  </Typography>
                  <Card variant="outlined" sx={{ p: 2 }}>
                    <Grid container spacing={2}>

                      <>
                        {/* First Row */}
                        <Grid item xs={6}>
                          <TextField
                            label="Vendor Name"
                            size="small"
                            fullWidth
                            variant="standard"
                            InputLabelProps={
                                {
                                     shrink: true,

                                }
                            }
                            value={props.data && props.data.purchase_order_details.vendor_details?.vendor_name}
                            inputProps={
                              {
                                readOnly: true,
                              }
                            }

                          />
                        </Grid>
                        <Grid item xs={6}>
                          <TextField
                            label="Mobile Number"
                            size="small"
                            fullWidth
                            variant="standard"
                            InputLabelProps={
                                {
                                     shrink: true,

                                }
                            }
                            value={props.data && props.data.purchase_order_details.vendor_details?.mobile_number}
                            inputProps={
                              {
                                readOnly: true,
                              }
                            }
                          />
                        </Grid>

                        {/* Second Row */}
                        <Grid item xs={6}>
                          <TextField
                            label="Email ID"
                            size="small"
                            fullWidth
                            variant="standard"
                            InputLabelProps={
                                {
                                     shrink: true,

                                }
                            }
                            value={props.data && props.data.purchase_order_details.vendor_details?.email_address}
                            inputProps={
                              {
                                readOnly: true,
                              }
                            }
                          />
                        </Grid>
                        <Grid item xs={6}>
                          <TextField
                            label="GSTIN No."
                            size="small"
                            fullWidth
                            variant="standard"
                            InputLabelProps={
                                {
                                     shrink: true,

                                }
                            }
                            value={props.data && props.data.purchase_order_details.vendor_details?.gst_number}
                            inputProps={
                              {
                                readOnly: true,
                              }
                            }
                          />
                        </Grid>

                        {/* Third Row */}
                        <Grid item xs={6}>
                          <TextField
                            label="Address"
                            size="small"
                            fullWidth
                            variant="standard"
                            InputLabelProps={
                                {
                                     shrink: true,

                                }
                            }
                            value={props.data && props.data.purchase_order_details.vendor_details?.address}
                            inputProps={
                              {
                                readOnly: true,
                              }
                            }
                          />
                        </Grid>
                      </>

                    </Grid>
                  </Card>
                </Grid>

                {/* Bank Details Section */}
                <Grid item xs={12}>
                  <Typography variant="h6" gutterBottom>
                    Bank Details
                  </Typography>
                  <Card
                    variant="outlined"
                    sx={{
                      p: 3,
                      backgroundColor: "#f9f9f9",
                      boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
                      borderRadius: "8px",
                    }}
                  >
                    <Grid container spacing={3}>
                      <Grid item xs={6}>
                        <TextField
                          label="Bank Name"
                          size="small"
                          InputLabelProps={
                            {
                                shrink: true,
                            }
                          }
                          fullWidth
                          variant="standard"
                          value={props.data && props.data.purchase_order_details.vendor_details?.bank_name}
                          inputProps={
                            {
                              readOnly: true,
                            }
                          }
                          InputProps={{
                            sx: {  borderRadius: "4px" },
                          }}
                        />
                      </Grid>
                      <Grid item xs={6}>
                        <TextField
                          label="Account Name"
                          size="small"
                          InputLabelProps={
                            {
                                shrink: true,
                            }
                          }
                          fullWidth
                          variant="standard"
                          value={props.data && props.data.purchase_order_details.vendor_details?.bank_account_name}
                          inputProps={
                            {
                              readOnly: true,
                            }
                          }
                          InputProps={{
                            sx: { borderRadius: "4px" },
                          }}
                        />
                      </Grid>
                      <Grid item xs={6}>
                        <TextField
                          label="Account Number"
                          size="small"
                          fullWidth
                          InputLabelProps={
                            {
                                shrink: true,
                            }
                          }
                          variant="standard"
                          value={props.data && props.data.purchase_order_details.vendor_details?.bank_account_number}
                          inputProps={
                            {
                              readOnly: true,
                            }
                          }
                          InputProps={{
                            sx: {borderRadius: "4px" },
                          }}
                        />
                      </Grid>
                      <Grid item xs={6}>
                        <TextField
                          label="IFSC Code"
                          size="small"
                          fullWidth
                          variant="standard"
                          InputLabelProps={
                            {
                                shrink: true,
                            }
                          }
                          value={props.data && props.data.purchase_order_details.vendor_details?.ifsc_code}
                          inputProps={
                            {
                              readOnly: true,
                            }
                          }
                          InputProps={{
                            sx: { borderRadius: "4px" },
                          }}
                        />
                      </Grid>
                    </Grid>
                  </Card>
                </Grid>

              </Grid>
            </Card>
          </Box>

          {/* Terms and Conditions Section */}
          <Box mt={3} display="none">
            <Typography variant="h6" gutterBottom>
              Terms and Conditions
            </Typography>
            <Card
              variant="outlined"
              sx={{
                p: 3,
                backgroundColor: "#f9f9f9",
                boxShadow: "0 4px 8px rgba(36, 168, 63, 0.1)",
                borderRadius: "12px",
                border: "1px solid #24A83F",
              }}
            >
              <CardContent>
                <Typography variant="body2" gutterBottom sx={{ lineHeight: 1.6 }}>
                  <strong>1.</strong> Delivery time period is 10 days from the date of payment released.
                </Typography>
                <Typography variant="body2" gutterBottom sx={{ lineHeight: 1.6 }}>
                  <strong>2.</strong> Dispatch of devices shall be strictly on the basis of Advanced payment only. Apart from this, there shall not be any other clause applicable.
                </Typography>

              </CardContent>
            </Card>
          </Box>



          <Box mt={3} sx={{ display: 'flex', justifyContent: 'center', visibility:props.approve?'hidden': 'visible' }}>
            <Button id="previewButton" variant="contained" color="secondary" onClick={() => handleSubmit()}>
              Submit
            </Button>
          </Box>



          {/* Preview button */}
          <Box mt={3} sx={{ display:sessionStorage.getItem('UserType')==='ph'||sessionStorage.getItem('UserType')==='fh'? 'flex':'none', justifyContent: 'space-between',visibility:props.approve&&props.filter==='Pending'?'visible':'hidden'}}>
            <Button id="previewButton" variant="contained" color="success" onClick={() => handleOpenConfirmDialog("approved")}>
              Approve
            </Button>
            <Button id="previewButton" variant="contained" color="error" onClick={() => handleOpenConfirmDialog("rejected")}>
              Reject
            </Button>
          </Box>

          <div id="pagebreak"></div>


          {/* Preview Dialog */}
          <Dialog
            open={openPreview}
            onClose={() => setOpenPreview(false)}
            maxWidth="lg"
            fullWidth
            sx={{
              '& .MuiDialog-paper': {
                borderRadius: '12px',
                boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.2)',
                border: '1px solid #e0e0e0',
              },
            }}
          >
            <DialogTitle
              sx={{
                fontWeight: 'bold',
                fontSize: '1.25rem',
                borderBottom: '1px solid #e0e0e0',
                padding: '16px 24px',
              }}
            >
              Purchase Order Preview
              <Button
                variant="contained"
                color="error"
                onClick={() => setOpenPreview(false)}
                sx={{
                  float: 'right',
                  textTransform: 'none',
                  fontWeight: 'bold',
                  fontSize: '0.875rem',
                }}
              >
                Close
              </Button>
            </DialogTitle>
            <DialogContent
              sx={{
                padding: 0,
                backgroundColor: '#f9f9f9',
              }}
            >
              {pdfUrl ? (
                <iframe
                  src={pdfUrl}
                  title="Purchase Order Preview"
                  width="100%"
                  height="600px"
                  style={{
                    border: 'none',
                    padding: '16px',
                  }}
                />
              ) : (
                <Box
                  display="flex"
                  alignItems="center"
                  justifyContent="center"
                  height="100%"
                  padding="16px"
                >
                  <Typography variant="body1" color="textSecondary">
                    No preview available.
                  </Typography>
                </Box>
              )}
            </DialogContent>
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'flex-end',
                alignItems: 'center',
                padding: '16px 24px',
                borderTop: '1px solid #e0e0e0',
                backgroundColor: '#f9f9f9',
              }}
            >
              <Button
                variant="contained"
                color="primary"
                sx={{
                  textTransform: 'none',
                  fontWeight: 'bold',
                  display:'none'
                }}
                onClick={() => {
                  // Add submit logic here
                  console.log('Submit clicked!');
                  handlePostPurchaseOrder()
                  setOpenPreview(false); // Close the dialog after submission
                }}
              >
                Submit
              </Button>
            </Box>
          </Dialog>
        </CardContent>
      </Card>

    </Box>
  );
};

export default ViewPaymentOrder;
